import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Row } from 'reactstrap';
import OverviewCharts from './OverviewCharts';

const MarketOverview = (items: any) => {
  const [data, setData] = useState({
    Loss: [],
    Profit: [],
    labels: [],
    colors: [],
  });

  useEffect(() => {
    if (items?.items) {
      setData(items?.items[0]);
    }
  }, [items]);

  const renderItem = () =>
    data.labels.map((item: any, index) => {
      return (
        <div className="mt-0" key={index}>
          <div className="d-flex align-items-center">
            <div className="avatar-sm m-auto">
              <span className="avatar-title rounded-circle bg-soft-light text-dark font-size-16">
                {index + 1}
              </span>
            </div>
            <div className="flex-grow-1 ms-3">
              <span className="font-size-16">{item}</span>
            </div>
            <div className="flex-shrink-0">
              <span className="badge rounded-pill badge-soft-success font-size-12 fw-medium">
                {data.Profit[index]}
              </span>
            </div>
          </div>
        </div>
      );
    });

  return (
    <React.Fragment>
      <Col xl={10}>
        <Card>
          <CardBody>
            <div className="d-flex flex-wrap align-items-center mb-4">
              <h5
                style={{
                  color: `${
                    items?.items && items.items[0]?.ColorTitle !== undefined
                      ? items.items[0].ColorTitle
                      : '#495057'
                  }`,
                }}
                className="card-title me-2"
              >
                {items?.items && items.items[0]?.titleBar !== undefined
                  ? items.items[0].titleBar
                  : 'Orders by Commodity type'}
              </h5>
            </div>

            <Row className="align-items-center">
              <Col xl={8}>
                <div>
                  <div id="market-overview" className="apex-charts">
                    <OverviewCharts item={data} />
                  </div>
                </div>
              </Col>
              <Col xl={4}>
                <div className="p-4">{renderItem()}</div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default MarketOverview;
